// Extraído de WhatsAppPanel.jsx (02.3-client.md paso b) -- puro, sin dependencias del
// componente; movido a lib/ (mismo tratamiento que subPanelLabels.js) en vez de dejarlo como un
// named export junto al default de WhatsAppChatList.jsx (evita el warning de
// react-refresh/only-export-components).
export function formatChatTime(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  const now = new Date();
  if (date.toDateString() === now.toDateString()) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  }
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) {
    return 'Ayer';
  }
  return date.toLocaleDateString([], { day: '2-digit', month: '2-digit', year: '2-digit' });
}
